<template>
  <div class="stripe-payment">
    <StripeElements
      :stripe-key="stripeKey"
      :instance-options="instanceOptions"
      :elements-options="elementsOptions"
      #default="{ elements }"
      ref="elms"
    >
      <div class="cardElement">
        <StripeElement
          type="card"
          :elements="elements"
          :options="elementStyle"
          ref="card"
        />
      </div>
    </StripeElements>
    <span style="color: red" v-if="errors">{{ errors.message }}</span>
  </div>
</template>

<script>
import { StripeElements, StripeElement } from 'vue-stripe-elements-plus';
import Group from '@models/Group';

const elementStyle = {};

export default {
  name: 'StripePay',

  components: {
    StripeElements,
    StripeElement,
  },

  data() {
    return {
      elementStyle,
      stripeKey: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
      instanceOptions: {
        // https://stripe.com/docs/js/initializing#init_stripe_js-options
      },
      elementsOptions: {
        // https://stripe.com/docs/js/elements_object/create#stripe_elements-options
      },
      postalCodeOptions: {},
      errors: '',
    };
  },

  methods: {
    async pay(groupId, request) {
      delete request['verification_code'];
      this.errors = '';
      const groupComponent = this.$refs.elms;
      const card = this.$refs.card;
      const cardElement = card.stripeElement;
      await groupComponent.instance
        .createToken(cardElement)
        .then(async (result) => {
          if (result.error) {
            this.errors = result.error;
            this.$bus.$emit('payment_completed', response);
            return;
          }
          request['stripe_token'] = result.token.id;
          let model = new Group();
          let response = await model.checkoutWithStripe(groupId, request);
          if (response) {
            setTimeout(() => {
              $showSuccess(
                response.message || 'Successfully group checkout',
                'stripe-checkout-toast'
              );
            }, 1000);
          }
          this.$bus.$emit('payment_completed', response);
          // this.$bus.$emit('paids', this.dialog);
        });
    },
  },
  mounted() {
    this.$bus.$on('pay', (groupId, request) => {
      // console.log(loader);
      this.pay(groupId, request);
    });
  },
};
</script>

<style lang="scss">
.stripe-payment {
  .cardElement {
    height: 44px;
    border: 2px solid #c4c4c4;
    display: flex;
    align-items: center;
    padding: 0 12px;
    border-radius: 1px;
    > * {
      width: 100%;
    }
  }
  .row {
    display: flex;
    justify-content: space-between;
  }
  .cardNumber {
    width: 100%;
  }

  .cvc {
    max-width: 300px;
    min-width: 70px;
    width: 40%;
  }

  .expiryDate {
    max-width: 300px;
    min-width: 120px;
    width: 40%;
  }
}
</style>
